var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-content page-home"},[_c('QRAndBg'),_vm._v(" "),_c('BookAnServiceDesc'),_vm._v(" "),_c('BookReadingSymtem'),_vm._v(" "),_c('BookNumberDesc'),_vm._v(" "),_c('BooksDesc'),_vm._v(" "),_c('CourseDesc'),_vm._v(" "),_c('StoryDesc'),_vm._v(" "),_c('ContactUs',{attrs:{"whiteBg":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a26bffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = d1RO
// module chunks = 0